import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';
import IntervalRenderer from 'flow/components/custom-components/interval-renderer';
import { getPrettyDuration } from 'flow/utils/call-utils';
import moment from 'moment/moment';
import useAppContext from 'flow/hooks/useAppContext';
import OmnichannelIcon from 'flow/components/ui-components/OmnichannelIcon';

interface Props {
    title: string;
    subtitle: string;
    timestamp: string | number;
    iconKey: IconKey;
    queueName: string;
    position?: number;
    channelType?: IconKey;
}

const SupervisorCallPopover = ({
    title,
    subtitle,
    timestamp,
    iconKey,
    queueName,
    position,
    channelType,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex flex-col justify-between gap-1 p-2">
            <div className="flex items-center pb-3">
                {position ? (
                    <div className="bg-yellow me-1 flex size-8 items-center justify-center rounded-sm border-0">
                        {position}
                    </div>
                ) : null}

                <div className="ms-1 flex flex-col justify-between">
                    <div className="flex">
                        {channelType ? (
                            <div className="me-1 flex items-center">
                                <div className="size-4">
                                    <OmnichannelIcon
                                        channelType={channelType}
                                    />
                                </div>
                            </div>
                        ) : null}

                        <div className="truncate overflow-hidden text-sm text-ellipsis text-gray-800">
                            {title}
                        </div>
                    </div>
                    <div className="truncate overflow-hidden text-xs text-ellipsis text-gray-500">
                        {subtitle}
                    </div>
                </div>
            </div>
            <div className="flex gap-1.5 text-sm">
                <div className="flex items-center justify-around gap-2 rounded-sm border-0 bg-gray-200 py-1 ps-1.5 pe-2">
                    <Icon iconKey={iconKey} size={'1.25rem'} />
                    <span className="text-sm">
                        <IntervalRenderer interval={1000}>
                            {() =>
                                getPrettyDuration(
                                    moment.duration(
                                        moment().diff(moment(timestamp)),
                                    ),
                                )
                            }
                        </IntervalRenderer>
                    </span>
                </div>
                {queueName ? (
                    <div className="flex items-center justify-around rounded-sm bg-gray-200 px-2 py-1 whitespace-nowrap">
                        {i18next.t('general.call.via', {
                            queueOrNumber: queueName,
                            interpolation: { escapeValue: false },
                        })}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default React.memo(SupervisorCallPopover);
